<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    key() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  // min-height: calc(100vh - 50px);
  /* Subtract our own vertical padding (24 top + 14 bottom = 38px) so the box is
     exactly one viewport tall. Plain `100vh` + 38px padding made EVERY page 38px
     taller than the viewport, leaving a dead scroll strip below the content
     (most visible on short pages like an empty Overview or the chat page). */
  min-height: calc(100vh - 38px);
  width: 100%;
  position: relative;
  //overflow: hidden;
  padding: 24px 20px 14px;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}

.fade-transform--move,
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: opacity 0.25s ease;
}

.fade-transform-enter,
.fade-transform-leave-to {
  opacity: 0;
}
/* translateX removed — it caused sidebar nav and page headers to shift left/right on navigation */
</style>

<style lang="scss">
/* Always reserve the scrollbar gutter so its width doesn't come and go with
   page height — `overflow-y: overlay` used to do this by floating the
   scrollbar on top of content, but it's deprecated and current Chrome treats
   it as plain `auto`, which reserves space only when a page overflows and
   was shifting content left/right when switching to a shorter tab/filter. */
html {
  overflow-y: scroll;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #D1CCC3;
  border-radius: 4px;
  &:hover {
    background-color: #B5B0A6;
  }
}
</style>
